import type { MapDrillBreadcrumb } from "../location/location-map-utils";

export const splitMapDrillBreadcrumbTrail = (
	crumbs: MapDrillBreadcrumb[],
): {
	collapsed: MapDrillBreadcrumb[];
	current?: MapDrillBreadcrumb;
	parent?: MapDrillBreadcrumb;
	visible: MapDrillBreadcrumb[];
} => {
	if (crumbs.length === 0) {
		return { collapsed: [], visible: [] };
	}

	const current = crumbs[crumbs.length - 1];
	const parents = crumbs.slice(0, -1);
	const parent = parents[parents.length - 1];

	if (parents.length > 2) {
		return {
			collapsed: parents.slice(0, -1),
			current,
			parent,
			visible: parent && current ? [parent, current] : crumbs,
		};
	}

	return { collapsed: [], current, parent, visible: crumbs };
};
